import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { AINav } from "./components/ai/AINav";
import { AIHero } from "./components/ai/AIHero";
import { IndustryPicker } from "./components/ai/IndustryPicker";
import { AIProducts } from "./components/ai/AIProducts";
import { SurveillanceFlow } from "./components/ai/SurveillanceFlow";
import { WhySection } from "./components/ai/WhySection";
import { TestimonialsSection } from "./components/ai/TestimonialsSection";
import { AIFooter } from "./components/ai/AIFooter";
import { getIndustryData } from "./data/industries";
import "./styles/fonts.css";
function App() {
  const [selectedIndustry, setSelectedIndustry] = useState("doctor");
  const industryData = getIndustryData(selectedIndustry);
  return /* @__PURE__ */ jsxs("div", { className: "min-h-screen bg-white", style: { fontFamily: "'Inter', sans-serif" }, children: [
    /* @__PURE__ */ jsx("style", { children: `
        html { scroll-behavior: smooth; }
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { width: 5px; }
        ::-webkit-scrollbar-track { background: #f8fafc; }
        ::-webkit-scrollbar-thumb { background: rgba(111,92,247,0.3); border-radius: 3px; }
        ::-webkit-scrollbar-thumb:hover { background: rgba(111,92,247,0.55); }
        ::selection { background: rgba(111,92,247,0.15); color: #111827; }

        /* Orb + float animations defined globally so hero can use them */
        @keyframes orb-pulse {
          0%,100%{ box-shadow: 0 0 40px 8px rgba(111,92,247,0.2), 0 0 80px 20px rgba(111,92,247,0.08); }
          50%{ box-shadow: 0 0 60px 16px rgba(111,92,247,0.32), 0 0 120px 40px rgba(111,92,247,0.14); }
        }
        @keyframes ring1 { 0%,100%{transform:scale(1);opacity:0.3;} 50%{transform:scale(1.06);opacity:0.12;} }
        @keyframes ring2 { 0%,100%{transform:scale(1);opacity:0.2;} 50%{transform:scale(1.08);opacity:0.08;} }
        @keyframes ring3 { 0%,100%{transform:scale(1);opacity:0.12;} 50%{transform:scale(1.1);opacity:0.05;} }
        @keyframes orbit { from{transform:rotate(0deg);} to{transform:rotate(360deg);} }
        @keyframes counter-orbit { from{transform:rotate(0deg);} to{transform:rotate(-360deg);} }
        @keyframes float-pill { 0%,100%{transform:translateY(0);} 50%{transform:translateY(-6px);} }
        @keyframes gradient-shift {
          0%,100%{background-position:0% 50%;}
          50%{background-position:100% 50%;}
        }
        .gradient-text {
          background: linear-gradient(135deg,#6f5cf7 0%,#8b5cf6 40%,#a855f7 70%,#6f5cf7 100%);
          background-size: 200% 200%;
          animation: gradient-shift 4s ease-in-out infinite;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      ` }),
    /* @__PURE__ */ jsx(AINav, {}),
    /* @__PURE__ */ jsx(AIHero, {}),
    /* @__PURE__ */ jsx(IndustryPicker, { selected: selectedIndustry, onSelect: setSelectedIndustry }),
    /* @__PURE__ */ jsx(AIProducts, { data: industryData }, `products-${selectedIndustry}`),
    /* @__PURE__ */ jsx(SurveillanceFlow, {}),
    /* @__PURE__ */ jsx(WhySection, {}),
    /* @__PURE__ */ jsx(TestimonialsSection, { data: industryData, selectedId: selectedIndustry }, `testimonials-${selectedIndustry}`),
    /* @__PURE__ */ jsx(AIFooter, {})
  ] });
}
export {
  App as default
};
